// PLSA Retirement Living Standards 2024/25
// Source: Pensions and Lifetime Savings Association
// Update annually when PLSA publishes new figures.

export const PLSA = {
  single: {
    minimum:     14400,
    moderate:    31300,
    comfortable: 43100,
  },
  couple: {
    minimum:     22400,
    moderate:    43100,
    comfortable: 59000,
  },
} as const;

export type PLSAStandard = 'minimum' | 'moderate' | 'comfortable';
